import type { GetStaticProps } from 'next'
import type { FC } from 'react'
import type { Category } from '@/types'

import { Seo } from '@/components/generals/seo'
import { SiteLayout } from '@/components/layout/site-layout'

import {
    AboutHero,
    Faq,
    GoldenCta,
    Philosophy,
    Testimonials
} from '@/components/about'

import { getLayoutData } from '@/lib/layout-data'

interface AboutProps {
    categories: Category[]
}

const DESCRIPTION =
    'In the business since 1972. Discover the philosophy behind Milano, what our customers say, and the answers to the questions we hear most.'

const About: FC<AboutProps> = ({ categories }) => {
    return (
        <SiteLayout categories={categories}>
            <Seo title='About' description={DESCRIPTION} />

            <AboutHero />

            <Philosophy />

            <Testimonials />

            <Faq />

            <GoldenCta />
        </SiteLayout>
    )
}

export const getStaticProps: GetStaticProps<AboutProps> = async () => {
    const { categories } = getLayoutData()

    return {
        props: {
            categories
        }
    }
}

export default About
